import React from 'react';
import {Route} from 'react-router-dom';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';

export default [
  // FIXME: :type? now matches any value (was a ring/watch enum); invalid-value behavior pending demo verification
  <Route
    key="/business/showcase/3d-viewer/playground"
    element={<ShowocaseLayout />}
  >
    <Route path="business/showcase/3d-viewer/:type?" element={<AsyncPage />} />
  </Route>,
];
